import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import { addClass } from '@/utils/dom';
var timer = null;
var content = null;
var success = '<svg id="success" viewBox="0 0 72 72"><g fill="none" fill-rule="evenodd"><path d="M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36zm0-2c18.778 0 34-15.222 34-34S54.778 2 36 2 2 17.222 2 36s15.222 34 34 34z" fill="#FFF"></path><path stroke="#FFF" stroke-width="2" d="M19 34.54l11.545 11.923L52.815 24"></path></g></svg>';
var loading = '<svg id="loading" viewBox="0 -2 59.75 60.25"><path fill="#ccc" d="M29.69-.527C14.044-.527 1.36 12.158 1.36 27.806S14.043 56.14 29.69 56.14c15.65 0 28.334-12.686 28.334-28.334S45.34-.527 29.69-.527zm.185 53.75c-14.037 0-25.417-11.38-25.417-25.417S15.838 2.39 29.875 2.39s25.417 11.38 25.417 25.417-11.38 25.416-25.417 25.416z"></path><path fill="none" stroke="#108ee9" stroke-width="3" stroke-linecap="round" stroke-miterlimit="10" d="M56.587 29.766c.37-7.438-1.658-14.7-6.393-19.552"></path></svg>';
var fail = '<svg id="fail" viewBox="0 0 74 74"><g fill="none" fill-rule="evenodd"><path d="M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36zm0-2c18.778 0 34-15.222 34-34S54.778 2 36 2 2 17.222 2 36s15.222 34 34 34z" fill="#FFF"></path><path d="M22 22l28.304 28.304m-28.304 0L50.304 22" stroke="#FFF" stroke-width="2"></path></g></svg>';
var warn = "<svg id=\"warn\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\">\n  <rect width=\"24\" height=\"24\" rx=\"12\" fill=\"#FF9045\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.8173 5.79243C13.8173 4.80294 12.9996 4.00081 11.9908 4.00081L11.991 4.00081C11.9725 4.00026 11.9539 3.99999 11.9354 4C10.9267 4.00034 10.1092 4.80275 10.1096 5.79224L10.1096 5.79243C10.1096 6.53971 10.1041 6.89345 10.1087 7.24705C10.1187 8.01249 10.176 8.77731 10.4383 13.5322C10.4383 14.3584 11.1211 15.0282 11.9634 15.0282C12.8057 15.0282 13.4885 14.3584 13.4885 13.5322C13.7537 8.68882 13.8094 7.93068 13.8185 7.17199C13.8225 6.83335 13.8173 6.49461 13.8173 5.79243ZM10 18.0292C9.99496 19.1127 10.8863 19.995 11.9908 20H12.0091C13.1137 19.995 14.005 19.1127 13.9999 18.0292L13.9999 18.0292C13.9949 16.9527 13.1065 16.0813 12.0091 16.0764C10.9046 16.0714 10.0051 16.9457 10 18.0292Z\" fill=\"white\"/>\n</svg>";
var suc = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\">\n  <rect width=\"24\" height=\"24\" rx=\"12\" fill=\"#55CC3D\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.1499 16.6841C12.7752 17.7213 11.6361 18.2563 10.6056 17.8791C10.3212 17.775 10.0642 17.6069 9.85424 17.3875C7.20181 14.6138 4.81939 12.9112 6.63798 11.1527C8.31361 9.55406 9.86219 11.6403 10.6881 12.5036C13.0705 7.85948 15.2067 4.79006 17.2318 6.46066C19.7254 8.50694 15.5562 10.2175 13.1499 16.6841V16.6841Z\" fill=\"white\"/>\n</svg>";
var load = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.9958 2.48703C21.0596 1.57003 20.3744 0.774486 19.4655 0.710138C19.4257 0.707321 19.3858 0.705961 19.3459 0.70606H4.65391C3.74271 0.703805 3.00224 1.44718 3 2.36643C2.99991 2.40667 3.00126 2.44689 3.00405 2.48703C3.40001 6.73972 5.16537 10.3433 7.62366 12.3489C5.14887 14.3463 3.40001 17.9582 3.0123 22.2192C2.94749 23.1361 3.63174 23.9324 4.54063 23.9978C4.55363 23.9988 4.56664 23.9995 4.57967 24.0002H19.4284C20.3386 23.9565 21.0414 23.1768 20.9981 22.2586C20.9975 22.2454 20.9967 22.2323 20.9958 22.2192C20.6081 17.9582 18.8427 14.3463 16.3844 12.3489C18.8592 10.3516 20.6081 6.73972 20.9958 2.48703ZM17.0773 19.3064C17.0773 19.3064 14.6924 17.278 11.9999 17.2766C9.30741 17.2752 6.92244 19.298 6.92244 19.298C7.94536 15.9691 9.92519 14.0134 12.004 14.0134C14.0828 14.0134 16.0709 15.9691 17.0773 19.3064ZM17.4238 4.02656H6.58426C7.40919 8.13777 9.59525 10.6178 11.9133 10.6844H12.0948C14.4129 10.6178 16.5989 8.13777 17.4238 4.02656Z\" fill=\"#33BBFF\"/>\n</svg>";
var svg = {
  success: success,
  loading: loading,
  loadingV2: loading,
  fail: fail,
  warn: warn
};
var svgV2 = {
  success: suc,
  loading: load,
  loadingV2: load,
  fail: fail,
  warn: warn
};

var Toast = function () {
  function Toast() {
    this.body = document.body;
  }

  Toast.prototype.getTemplate = function (msg, type) {
    if (type === void 0) {
      type = 'text';
    }

    return (
      /* html */
      "<div class=\"ui-toast-content\">\n        ".concat(type === 'text' ? '' : "<div class=\"ui-toast-icon ".concat(['loading', 'loadingV2'].includes(type) ? 'am-spin' : '', "\">").concat(svg[type], "</div>"), "\n      <div class=\"text\">").concat(msg, "</div>\n  </div>\n  ")
    );
  };

  Toast.prototype.getTemplateV2 = function (msg, type) {
    if (type === void 0) {
      type = 'text';
    }

    return (
      /* html */
      "<div class=\"ui-toast-content2 ".concat(type === 'loading' ? 'loading-content' : '', "\">\n        ").concat(type === 'text' ? '' : "<div class=\"ui-toast-icon ".concat(['loading', 'loadingV2'].includes(type) ? 'am-spin' : '', "\">").concat(svgV2[type], "</div>"), "\n      <div class=\"text\">").concat(msg, "</div>\n  </div>\n  ")
    );
  };

  Toast.prototype.factory = function (ops, fn) {
    var _this = this;

    if (!ops.msg) {
      return;
    }

    this.hide();
    content = document.createElement('div');
    addClass(content, 'ui-toast');
    content.innerHTML = ops.version === 'v2' ? this.getTemplateV2(ops.msg, ops.type) : this.getTemplate(ops.msg, ops.type);
    this.body.appendChild(content);
    timer = setTimeout(function () {
      if (typeof fn === 'function') {
        fn();
      }

      _this.hide();

      timer = null;
    }, ops.delay < 20 ? ops.delay * 1000 : ops.delay);
  };

  Toast.prototype.success = function (msg, delay, fn) {
    if (delay === void 0) {
      delay = 3000;
    }

    this.factory({
      msg: msg,
      delay: delay,
      type: 'success'
    }, fn);
  };

  Toast.prototype.loading = function (msg, delay, fn) {
    if (delay === void 0) {
      delay = 3000;
    }

    this.factory({
      msg: msg,
      delay: delay,
      type: 'loading'
    }, fn);
  };

  Toast.prototype.fail = function (msg, delay, fn) {
    if (delay === void 0) {
      delay = 3000;
    }

    this.factory({
      msg: msg,
      delay: delay,
      type: 'fail'
    }, fn);
  };

  Toast.prototype.info = function (msg, delay, fn) {
    if (delay === void 0) {
      delay = 3000;
    }

    this.factory({
      msg: msg,
      delay: delay,
      type: 'text'
    }, fn);
  }; // 2.0 版本Toast


  Toast.prototype.text = function (msg, delay, fn) {
    if (delay === void 0) {
      delay = 3000;
    }

    this.factory({
      msg: msg,
      delay: delay,
      type: 'text',
      version: 'v2'
    }, fn);
  };

  Toast.prototype.warning = function (msg, delay, fn) {
    if (delay === void 0) {
      delay = 3000;
    }

    this.factory({
      msg: msg,
      delay: delay,
      type: 'warn',
      version: 'v2'
    }, fn);
  };

  Toast.prototype.successed = function (msg, delay, fn) {
    if (delay === void 0) {
      delay = 3000;
    }

    this.factory({
      msg: msg,
      delay: delay,
      type: 'success',
      version: 'v2'
    }, fn);
  };

  Toast.prototype.load = function (msg, delay, fn) {
    if (delay === void 0) {
      delay = 3000;
    }

    this.factory({
      msg: msg,
      delay: delay,
      type: 'loading',
      version: 'v2'
    }, fn);
  };

  Toast.prototype.loadV2 = function (msg, delay, fn) {
    if (delay === void 0) {
      delay = 3000;
    }

    this.factory({
      msg: msg,
      delay: delay,
      type: 'loadingV2',
      version: 'v2'
    }, fn);
  };

  Toast.prototype.hide = function () {
    if (content) {
      clearTimeout(timer);
      this.body.removeChild(content);
      content = null;
    }
  };

  return Toast;
}();

export default new Toast();